// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@ces/App/Store/Selectors/SettingsSelectors";
import { executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, UpdatePrice } from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/ChangeProductQty";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

export const XngUpdatePrice: typeof UpdatePrice = async props => {
    const {
        parameter: { productId, unitOfMeasure, qtyOrdered, product },
    } = props;

    // <xng-change>
    const seePricing = getSettingsCollection(props.getState()).customSetting?.showPricing;
    const { isAuthenticated } = props.getState().context.session;

    if (product.quoteRequired || (seePricing === "Secure" && !isAuthenticated)) {
        return;
    }
    // </xng-change>

    const realTimePricingModel = await executeAwaitableHandlerChain<
        Parameters<typeof loadRealTimePricing>[0],
        RealTimePricingModel
    >(loadRealTimePricing, { productPriceParameters: [{ productId, unitOfMeasure, qtyOrdered }] }, props);
    props.pricing = realTimePricingModel.realTimePricingResults?.find(o => o.productId === productId);
};

replaceInChain(chain, UpdatePrice, XngUpdatePrice);
